import axios from 'axios';
import { __ } from "../app"
import {  apiHost, authHost } from '../config'
import {  fetchResultsByTerm, useFetchResultByUrl } from './helpers/autocomplete-service';

export async function autocomplete( term, { abortController = AbortController } ) {
    var url = apiHost + '/api/admin/vendor/autocomplete';
    return await fetchResultsByTerm( url, term, { abortController } )
}

export function useVendor( vendorId = false, { context = 'autocomplete' } = {} ) {

    var fetchParams = {
        getId: r => r?.id,
        getUrl: r => apiHost + '/api/admin/vendor/' + parseInt( r?.id ),
        initialState: {
            id: vendorId
        }
    } 

    if( context == 'autocomplete' ) {
        fetchParams = {
            getId: r => r?.vendorId,
            getUrl: r => apiHost + '/api/admin/vendor/autocomplete/' + parseInt( r?.vendorId ),
            initialState: {
                vendorId: vendorId
            }
        }
    }

    return useFetchResultByUrl( fetchParams );
}


export async function createVendor( vendorModel ) {
    
    try {
        const response = await axios.post( apiHost + '/api/admin/vendor',  { 
            ...vendorModel,
            id: 0
        } );

        return response;
    }
    catch( e ) {
        return {
            error: true,
            message: e?.response?.data
        }
    }
}



export async function updateVendor( vendorModel ) {

    try {
        const response = await axios.put( apiHost + '/api/admin/vendor/' + vendorModel?.id, vendorModel )
        return response;
    }
    catch( e ) {
        return {
            error: true,
            message: e?.response?.data
        }
    }
}

export async function createCredentials( vendorId, name ) {
    var url = apiHost + '/api/admin/vendor/' + vendorId + '/credentials/create';
    var response = axios.put( url, {
        clientName: name
    } );

    return response;
}